import { Component, Input } from '@angular/core';
import {NgClass, NgStyle} from '@angular/common';

@Component({
  selector: 'app-parallax-section',
  standalone: true,
  template: `
    <section class="parallax-section d-flex align-items-center"
             [ngStyle]="{
        'background-image': 'url(' + backgroundImage + ')',
        'min-height': minHeight
      }">
      <div class="container w-100" [ngClass]="containerClass">
        <ng-content></ng-content>
      </div>
    </section>
  `,
  imports: [
    NgStyle,
    NgClass
  ],
  styleUrls: ['./parallax-section.component.scss']
})
export class ParallaxSectionComponent {
  @Input() backgroundImage: string = '';         // Image URL (required)
  @Input() minHeight: string = '320px';          // Customizable height
  @Input() containerClass: string = '';          // For further custom styling if needed
}
